// extracted by css-extract-rspack-plugin
export default {"popover":"XLBc0v9kWC8HpBut"};